import SellerDrawer from './SellerDrawer.component';

export default SellerDrawer;
